<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div style="background-color: #fff; min-height: 100vh;">
  <div class="container py-3">
    <div class="row">
      <div class="col-12 p-0">
        <h3 class="font-weight-bold" style="font-size: 18px;">{{sellerInfo?.BranchName}} <small class="text-muted"
            style="font-size: 16px;">({{sellerInfo.BranchType}})</small></h3>

        <div class="input-group mb-2">
          <input class="form-control" [placeholder]="sellerInfo.BranchContact"
            style="opacity: 0.65; box-shadow: none; pointer-events: none;" />

          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="copyContactNumber()">
              <i class="fa fa-copy"></i>
            </button>
            <button class="btn btn-outline-primary" type="button" (click)="callThisNumber()">
              <i class="bi bi-telephone-fill"></i>
            </button>
            <button class="btn btn-outline-success" type="button" (click)="whatsAppThisNumber()" title="WhatsApp">
              <i class="bi bi-whatsapp"></i>
            </button>
          </div>
        </div>

        <div class="text-uppercase text-muted small mb-2" style="font-size: 13px;">{{sellerInfo.Place}}</div>

        <div class="mb-2">
          <div class="small">Username : <span class="text-dark font-weight-bold">{{sellerInfo.Username}}</span> | psd
            : <span class="text-dark font-weight-bold">{{sellerInfo.Password}}</span></div>

          <div class="small mt-1">Last Paid : <span class="text-dark font-weight-bold">{{sellerDetails?.LastPaidDate ?
              formatUnixToReadable(sellerDetails?.LastPaidDate) : '--'}}</span>
            | Payment Status : <span class="text-danger font-weight-bold">{{sellerDetails?.PaymentStatus}}</span></div>
          <div class="small mt-1">Monthly Credit : <span
              class="text-dark font-weight-bold">{{sellerDetails.MonthlyCredit}}</span> | Monthly Usage : <span
              class="text-dark font-weight-bold">{{sellerDetails.MonthlyUsage}}</span></div>
          <div class="small mt-1">Payment Banner Status : <span
              [class.text-success]="sellerDetails.EnablePaymentBanner===true"
              [class.text-secondary]="sellerDetails.EnablePaymentBanner===false"
              class="font-weight-bold">{{sellerDetails.EnablePaymentBanner ? "Enabled" : "Not Enabled" }}</span></div>
          <div class="small mt-1">Whatsapp : <span [class.text-success]="sellerDetails.WhatsappEnabled"
              [class.text-secondary]="!sellerDetails.WhatsappEnabled"
              class="font-weight-bold">{{sellerDetails.WhatsappEnabled ? "Enabled" : "Not Enabled"}}</span> |
            Is Core User
            : <span [class.text-success]="sellerDetails.CoreUser" [class.text-secondary]="!sellerDetails.CoreUser"
              class="font-weight-bold">{{sellerDetails.CoreUser ? "Yes" : "No"}}</span></div>
          <div class="small mt-2">Amount To Pay : <span
              class="font-weight-bold">{{sellerDetails.PendingBillAmount}}</span></div>

          <div *ngIf="currentPlanInfo" class="small mt-2">Plan : 
            <span class="font-weight-bold">{{currentPlanInfo?.PlanName}}</span> | <span class="font-weight-bold">{{currentPlanInfo?.BillCycle}}</span> | <span class="font-weight-bold">{{currentPlanInfo?.BillingType}}</span>
          </div>
          <div *ngIf="!currentPlanInfo" class="small mt-2">Plan : 
             <span class="ml-1 font-weight-bold">--</span>
          </div>
        </div>

      </div>
    </div>
  </div>

  <hr class="w-100">

  <div class="page-tab-container">
    <div class="d-flex px-2 w-100" style="gap: 0.5rem;">
      <div (click)="changePage(1)" class="py-2 w-50">
        <div class="page-tabs"
          [ngStyle]="page==1 ? {'background-color':'#673AB7', 'color':'#fff' } : {'background-color':'#B39CDB33','color':'#888888'}">
          Actions
        </div>
      </div>
      <div (click)="changePage(2)" class="py-2 w-50">
        <div class="page-tabs"
          [ngStyle]="page==2 ? {'background-color':'#673AB7', 'color':'#fff'} : {'background-color':'#B39CDB33','color':'#888888'}">
          Old Invoices
        </div>
      </div>
      <div (click)="changePage(3)" class="py-2 w-50">
        <div class="page-tabs"
          [ngStyle]="page==3 ? {'background-color':'#673AB7', 'color':'#fff'} : {'background-color':'#B39CDB33','color':'#888888'}">
          New Invoices
        </div>
      </div>
    </div>
  </div>

  <hr class="w-100">

  <div *ngIf="page==1" class="p-3">
    <div class="d-flex flex-column " style="gap: 1rem;">

      <div class="d-flex flex-column " style="gap: 0.5rem;">
        <div class="sub-heading">Payment</div>
        <div class="d-flex align-items-center" style="gap: 0.5rem;">
          <button class="btn btn-primary" (click)="confirmPayBill()">Pay Bill</button>
        </div>
      </div>

      <div class="d-flex flex-column " style="gap: 0.5rem;">
        <div class="sub-heading">Limit</div>
        <div class="d-flex align-items-center" style="gap: 0.5rem;">
          <button class="btn btn-danger" (click)="confirmUpdateCredit()">Update Credit Limit</button>
        </div>
      </div>

      <div class="d-flex flex-column " style="gap: 0.5rem;">
        <div class="sub-heading">Status</div>
        <div class="d-flex flex-wrap align-items-center" style="gap: 0.5rem;">
          <button class="btn btn-warning px-4" [class.active]="isBannerActive" (click)="confirmToggleBanner()">Pay
            Banner</button>
          <button class="btn btn-success px-4" [class.active]="isWhatsappActive"
            (click)="confirmToggleWhatsapp()">Whatsapp</button>
          <button class="btn btn-danger px-4" [class.active]="isCoreUserActive" (click)="confirmToggleCoreUser()">Core
            User</button>
        </div>
      </div>

      <div class="d-flex flex-column " style="gap: 0.5rem;">
        <div class="sub-heading">Migration</div>
        <div class="d-flex align-items-center" style="gap: 0.5rem;">
          <button class="btn btn-success" (click)="confirmMigrateSeller()">Branch to V2</button>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="page==2" class="p-3">
    <div class="list-section">
      <ng-container *ngIf="loading; else realContent">
        <div class="serviceItem d-flex p-2 my-2" *ngFor="let _ of [].constructor(5)">
          <!-- Left Job Box -->
          <div class="mr-2">
            <div class="jobBox d-flex flex-column align-items-center justify-content-center p-2 skeleton-box"
              style="width:80px; height:90px;">

              <div class="skeleton-text very-short mb-1"></div>
              <div class="d-flex align-items-center">
                <div class="skeleton-text very-short"></div>
              </div>

            </div>
          </div>

          <!-- Right Content -->
          <div class="row no-gutters w-100" style="overflow: hidden;">
            <div class="d-flex align-items-center justify-content-between w-100">

              <!-- Left Text Block -->
              <div class="d-flex flex-column w-75">
                <div class="skeleton-text short mb-1"></div>
                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short"></div>
              </div>

              <!-- Right Amount Block -->
              <div class="d-flex flex-column align-items-end w-25">
                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short mb-1"></div>

                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short"></div>
              </div>

            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #realContent>
        <div *ngIf="usageInvoices.length==0" class="no-data-message text-center ">
          No invoices data found.
        </div>
        <ng-container *ngIf="usageInvoices.length!=0">
          <form [formGroup]="whatsAppForm">
            <div formArrayName="entries">
              <div class=" d-flex flex-column workorder-card my-2" *ngFor="let item of usageInvoices; let i = index" >

                <div class="d-flex p-2 py-1">
                  <div class="d-flex flex-column first-section">
                    <div class="d-flex flex-fill">
                      <div class="flex-fill" style="border-radius: 6px; border-width: 0.01rem ; border-style: solid;"
                        [ngStyle]="{ 'border-color' : 'rgba(3, 155, 229)'}">
                        <div class="d-flex flex-column justify-content-center align-items-center h-100">
                          <div class="delivery-date d-flex flex-column align-items-center pt-2 pb-1"
                            [ngStyle]="{'color': 'rgba(3, 155, 229)'}">
                            <div>Total Cost</div>
                            <div class="day">{{item?.TotalCost}}</div>
                          </div>

                          <hr class="w-100 my-0">

                          <div class="delivery-date d-flex flex-column align-items-center pb-2 pt-1" >
                            <div>Total Count</div>
                            <div class="day" style="font-size: 18px;">{{item?.TotalCount}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="pl-2 d-flex flex-column flex-fill" style="min-width: 0;overflow: hidden;">

                    <div class="d-flex align-items-center justify-content-between w-100 h-100">
                      <div class="d-flex flex-column justify-content-between h-100">
                        <div>
                          <div class="d-flex align-items-center" style="color: #6c757d; font-size: 0.85rem;">
                            Bill Period : {{item?.InvoiceDate}}
                          </div>
                          <div class="d-flex flex-column align-items-start " style="font-size: 0.65rem;">
                            <div>
                              Company Cost:
                              <span style="font-weight: 500;">{{item?.CompanyCost}}(Count:
                                {{item?.CompanyCount}})</span>
                            </div>
                            <div>
                              Shop Cost:
                              <span style="font-weight: 500;">{{item?.ShopCost}}(Count: {{item?.ShopCount}})</span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center " style="color: #6c757d; font-size: 0.75rem;">
                          <div (click)="toggleMessage(item, $event)" class="bill-message" [ngClass]="{'two-line-ellipsis': !item._showFullMessage}">
                            <span class="bill-message-text">{{item?.BillMessage}}</span>
                            <a *ngIf="isLongMessage(item?.BillMessage)" class="text-primary bill-toggle-inline"
                               style="background-color: #fff;">
                              {{item._showFullMessage ? 'less' : '...more'}}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center p-2" style="gap: 0.5rem;" [formGroupName]="i">
                  <input formControlName="phoneNo" id="search" class="form-control search-input" type="text"
                    placeholder="Phone" style="height: 40px;" />
                  <button type="button" class="btn btn-success py-1" style="font-size: 0.65rem;"
                    (click)="sendWhatsApp(i, item)">Send to Whatsapp</button>
                </div>

              </div>
            </div>
          </form>
        </ng-container>
      </ng-template>
    </div>
  </div>

  <div *ngIf="page==3" class="px-3 py-2">
    <div class="bg-white" >
      <div *ngIf="!bills || bills.length==0" class="no-data-message text-center ">
        No Data Listed
      </div>
      <div *ngIf="bills && bills.length!=0" class="list-container" style="overflow-y: auto;">
        <div class="serviceItem d-flex p-2 my-2" *ngFor="let item of bills">
          <div class="row no-gutters w-100" style="overflow: hidden;">
            <div class="d-flex align-items-start justify-content-between w-100 ">
              <div class="d-flex flex-column ">
                <div class="customerName mb-1 ellipsis" style="max-width: 200px;">
                  {{item?.PlanName}}
                </div>
                <div class="d-flex align-items-center w-100">
                </div>
  
                <div class="d-flex align-items-center w-100 my-1">
                  <div class=" d-flex align-items-center ellipsis" style="max-width: 130px;">
                    <i class="bi bi-calendar-check mr-1" style="font-size: 13px; color: #757575;"></i> <strong
                      style="color:#757575; font-size: 13px;">{{item?.BillCycle}}</strong>
                  </div>
                  <span class="mx-2" style="font-size: 13px;">|</span>
                  <div class=" d-flex align-items-center ">
                    <i class="bi bi-credit-card mr-1" style="font-size: 13px; color: #757575;"></i> <strong
                      style="color:#757575; font-size: 13px;">{{item?.BillingType}}</strong>
                  </div>
                </div>
  
                <div class="d-flex align-items-center justify-content-between w-100">
                  <div class="paidAmount text-secondary" style="font-size: 13px;">
                    Start: {{item?.StartDateUnix * 1000 | date:'dd MMM yyyy'}} - End:
                    {{item?.EndDateUnix*1000 | date:'dd MMM yyyy'}}
                  </div>
                </div>
  
              </div>
  
              <div class="d-flex flex-column justify-content-start h-100 ">
                <div class="d-flex flex-column align-items-end">
                  <div style="font-size: 12px; color: #757575;">Amount</div>
                  <div style="font-size: 14px; font-weight: 600;">{{item?.TotalAmount | currency :
                    'INR' :
                    'symbol' : '1.0-0'}}</div>
                </div>
  
                <div *ngIf="!item?.isPendingBill; else notPaid" class="d-flex flex-column align-items-end mt-1">
                  <div style="font-size: 12px; color: #757575;" class="">Payment Dt</div>
                  <div style="font-size: 13px; font-weight: 600;">{{item?.PaymentDate | date:'dd MMM yy'}}</div>
                </div>

                <ng-template #notPaid>
                  <small class="text-danger mt-2" style="font-size: 13px; font-weight: 600;">Not Paid</small>
                </ng-template>
  
              </div>
            </div>
          </div>
  
        </div>
      </div>
    </div>
  </div>


  <!-- Confirm Modal -->
  <div *ngIf="confirmVisible" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{confirmTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="confirmVisible = false;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <p>{{confirmMessage}}</p>
        </div>

        <div *ngIf="confirmAmount" [formGroup]="amountForm" class="px-3 pb-3">
          <input formControlName="amount" class="form-control search-input" type="text"
                    placeholder="amount" style="height: 40px;" />
        </div>

        <div class="modal-footer">
          <div class="d-flex align-items-center justify-content-between w-100" style="gap: 0.5rem;">
            <button *ngIf="!isPaidJob" (click)="confirmCancel()" class=" btn btn-primary "
              style="background-color:#fff; color:#808080; border-color:#808080;flex: 1 1 0;">
              {{confirmCancelLabel}}
            </button>

            <button *ngIf="!isPaidJob" (click)="confirmCallback()" class=" btn btn-primary "
              style="background-color:#673AB7; color:#fff; border-color:#673AB7;flex: 1 1 auto; ">
              {{confirmConfirmLabel}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>